import * as React from "react";
import { Button } from "primereact/button";
import { useAppDispatch } from "../redux/store.ts";
import { AddNewCallback } from "../redux/slices/addNew.ts";
import { RowType } from "../types";

export const DropdownOpenAddNew = <TRow extends RowType>({
  onAddNew,
  row,
  filterValue,
}: {
  onAddNew: AddNewCallback<TRow>;
  row: Partial<TRow>;
  filterValue: React.RefObject<string>;
}) => {
  const dispatch = useAppDispatch();

  const driver_ids = React.useMemo(() => {
    const driver = (row as Record<string, unknown>)["driver"];
    const driverId = (row as Record<string, unknown>)["driverId"];

    return typeof driver === "number"
      ? driver
      : typeof driverId === "number"
        ? driverId
        : undefined;
  }, [row]);
  return (
    <div className="add-new-dropdown-option">
      <Button
        label="Dodać"
        icon="pi pi-plus"
        text
        aria-label="Add new option"
        onClick={() => {
          onAddNew({
            dispatch,
            // This is a but funky, hitting the types with a hammer, but it work better than before.
            data: { id: row.id },
            row: { ...row, driverId: driver_ids } as TRow,
            initialValueString: filterValue.current ?? "",
          });
        }}
      />
    </div>
  );
};
